<app-capture-history-item-title>
  {{ title }}
</app-capture-history-item-title>

<app-capture-history-item-body>
  {{ choreDisplayName }}, ID: {{ choreId }}

  @if (notes) {
    <div>
      Notes: {{ notes }}
    </div>
  }

  @if (error) {
    <div class="text-danger">
      Error: {{ error }}
    </div>
  }
</app-capture-history-item-body>
